import { Vue, Component, Ref, Emit } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue/src/components/modal'
import ValuableConceptsModalGrid from '@/components/valuable-concepts-modal/valuable-concepts-modal-grid/valuable-concepts-modal-grid.vue'
import ValuableConceptsModalGridComp from '@/components/valuable-concepts-modal/valuable-concepts-modal-grid/valuable-concepts-modal-grid'
import ValuableConceptsModalTree from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree.vue'
import ValuableConceptsModalTreeComp from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree'
import { initialValuableConceptsModalState, ValuableConceptsModalState, ValuableConceptsShowingProperties } from '@/components/valuable-concepts-modal/valuable-concepts-modal.model'
import { billingAppliedBillableConceptService } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { ValuableConceptsTreeNodeStructure } from '@/components/valuable-concepts-modal/valuable-concepts-modal-tree/valuable-concepts-modal-tree.model'
import ValuableConceptsModalSkeletonsTree from '@/components/valuable-concepts-modal/shared/components/skeletons/valuable-concepts-modal-skeletons-tree/valuable-concepts-modal-skeletons-tree.vue'
import ValuableConceptsModalSkeletonsTabs from '@/components/valuable-concepts-modal/shared/components/skeletons/valuable-concepts-modal-skeletons-tabs/valuable-concepts-modal-skeletons-tabs.vue'
import ValuableConceptsModalSkeletonsTable from '@/components/valuable-concepts-modal/shared/components/skeletons/valuable-concepts-modal-skeletons-table/valuable-concepts-modal-skeletons-table.vue'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { store } from '@/store/store'

@Component({
    components: {
        ValuableConceptsModalTree,
        ValuableConceptsModalGrid,
        ValuableConceptsModalSkeletonsTree,
        ValuableConceptsModalSkeletonsTabs,
        ValuableConceptsModalSkeletonsTable
    }
})
export default class ValuableConceptsModal extends Vue {
    @Ref() readonly valuableConceptsModal!: BModal
    @Ref() readonly valuableConceptsModalGrid!: ValuableConceptsModalGridComp
    @Ref() readonly valuableConceptsModalTree!: ValuableConceptsModalTreeComp

    @Emit()
    refresh(): void {}

    state: ValuableConceptsModalState
    constructor() {
        super()
        this.state = initialValuableConceptsModalState()
    }

    private _setSelectedAccountingUnitSum(accountingId?: number): void {
        if (this.state.accountingUnits) {
            const indexDefaultAccountingUnit = this.state.accountingUnits.findIndex(accountingUnitItem => accountingUnitItem.accountingUnit.isDefault)
            if (indexDefaultAccountingUnit !== -1) {
                this.state.activeTab = indexDefaultAccountingUnit
                this.state.selectedAccountingUnit = this.state.accountingUnits[this.state.activeTab]
            } else {
                this.state.selectedAccountingUnit = this.state.accountingUnits[this.state.activeTab] ?? null
            }
            if (accountingId) {
                const index = this.state.accountingUnits.findIndex(accountingUnit => accountingUnit.accountingUnit.id === accountingId)
                if (index !== -1) {
                    this.state.activeTab = index
                    this.state.selectedAccountingUnit = this.state.accountingUnits[this.state.activeTab]
                }
            }
        }
    }
    private async _getAccountingUnitSum(accountingId?: number): Promise<void> {
        if (this.state.caseId) {
            const response =
                await PromiseUtils.toCallSecure(
                    billingAppliedBillableConceptService.getSumPerAccountingUnit(
                        store.getters.labId,
                        this.state.caseId))
            this.state.accountingUnits = response ?? []
        }
        if (!this.state.selectedAccountingUnit) {
            this._setSelectedAccountingUnitSum(accountingId)
        }
    }

    show(showingProperties: ValuableConceptsShowingProperties): void {
        this.state = initialValuableConceptsModalState()
        this.state.initialSelectedNodeTree = showingProperties.entityConcept ?? null
        this.state.caseId = showingProperties.caseId
        this.state.promise = this._getAccountingUnitSum(showingProperties.accountingId)
        this.state.isBillingModule = showingProperties.isBillingModule
        this.state.caseStatus = showingProperties.caseState ?? null
        this.valuableConceptsModal.show()
    }

    onHide(): void {
        if (this.state.isDirty) {
            this.refresh()
        }
        this.valuableConceptsModal.hide()
    }

    onSelectedNode(node: ValuableConceptsTreeNodeStructure): void {
        this.state.selectedNodeTree = node

        if (this.state.selectedAccountingUnit && this.state.caseId) {
            const refGrid = ((this.valuableConceptsModalGrid as any)[0]) as ValuableConceptsModalGridComp
            refGrid?.updateDatasource(node.data, this.state.selectedAccountingUnit, this.state.caseId, this.state.isBillingModule, this.state.caseStatus)
        }
    }

    async onRefreshView(): Promise<void> {
        this.state.isDirty = true
        this.state.initialSelectedNodeTree = null
        await this._getAccountingUnitSum()
        const refTree = ((this.valuableConceptsModalTree as any)[0]) as ValuableConceptsModalTreeComp
        refTree?.loadTree()
    }

    onInputTabs(tabIndex: number): void {
        this.state.activeTab = tabIndex

        if (this.state.accountingUnits) {
            this.state.selectedAccountingUnit = this.state.accountingUnits[tabIndex]
        }
    }
}
